<template>
  <div>
    <v-data-table-server
      :headers="headers"
      :items="items"
      :items-length="total"
      :page="page"
      @update:page="$emit('update:page', $event)"
      :items-per-page="rows"
      @update:items-per-page="$emit('update:rows', $event)"
      :items-per-page-options="[25, 50, 100, 500]"
      :loading="loading"
    >
      <template v-slot:[`item.name`]="{ item }">
        <router-link
          :to="`/epigraphies/${item.uuid}/${item.discourseUuids}`"
          target="_blank"
          rel="noreferrer noopener"
          >{{ item.name }}</router-link
        >
      </template>

      <template v-slot:[`item.discourseUnits`]="{ item }"
        ><div>
          <table-discourse
            :discourseUnits="item.discourseUnits"
            :discourseUuids="item.discourseUuids"
          ></table-discourse>
        </div>
      </template>
    </v-data-table-server>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue';
import { WordsInTextsSearchResultRow } from '@oare/types';
import { DataTableHeader } from 'vuetify';
import TableDiscourse from './TableDiscourse.vue';

export default defineComponent({
  name: 'WordsInTextSearchTable',
  props: {
    items: {
      type: Array as PropType<WordsInTextsSearchResultRow[]>,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      default: 1,
    },
    rows: {
      type: Number,
      default: 25,
    },
    loading: {
      type: Boolean,
    },
  },
  components: { TableDiscourse },
  emits: {
    'update:page': (_page: number) => true,
    'update:rows': (_rows: number) => true,
  },
  setup() {
    const headers = ref<DataTableHeader[]>([
      { title: 'Text Name', key: 'name', width: '30%' },
      { title: 'Matching Discourse', key: 'discourseUnits', width: '70%' },
    ]);

    return {
      headers,
    };
  },
});
</script>
